import React, { useState, lazy } from 'react';
import { deriveMark } from '../cv/helpers';
interface Props {
  company: string;
  mark?: string;
  domain?: string;
  logo?: string;
  size?: number;
}
function sources(domain?: string, logo?: string): string[] {
  return [...(logo ? [logo] : []), ...(domain ? [`https://logos.hunter.io/${domain}`, `https://logo.debounce.com/${domain}`, `https://icons.duckduckgo.com/ip3/${domain}.ico`] : [])];
}
/** Company badge on the dark portfolio: white tile holding the brand logo. */
export function PortfolioMark({
  company,
  mark,
  domain,
  logo,
  size = 52
}: Props) {
  const list = sources(domain, logo);
  const [i, setI] = useState(0);
  const letters = (mark ?? deriveMark(company)).slice(0, 3);
  const src = list[i];
  return <span aria-hidden="true" className="flex shrink-0 select-none items-center justify-center overflow-hidden rounded-2xl border border-white/10 bg-white shadow-lg" style={{
    height: size,
    width: size,
    padding: size * 0.16
  }} data-id="element-282" data-mp="3lmy8leoxdje2">
      {src ? <img key={src} src={src} alt="" loading="lazy" onError={() => setI(n => n + 1)} className="h-full w-full object-contain" data-id="element-283" data-mp="2ciifgn780rxx" /> : <span className="font-display font-medium tracking-tight text-stone-900" style={{
      fontSize: size * (letters.length >= 3 ? 0.22 : 0.3)
    }} data-id="element-284" data-mp="2lix15no3k91y">
          {letters}
        </span>}
    </span>;
}